import { createContext, useContext } from "react"
import styled, { css } from "styled-components"

import { ApiTypes } from "types"

export const textDark = "#0f172a"
export const textGrey = "#64748b"
export const tealAccent = "#2ba4b8"
export const displayFont = `"Inter", sans-serif`
export const gradient = "linear-gradient(90deg, #67d6ee 0%, #a3e6d7 55%, #f4e3a1 100%)"

export const tabletBreakpoint = "1024px"
export const mobileBreakpoint = "768px"

export const gradientText = css`
  background: ${gradient};
  background-clip: text;
  -webkit-text-fill-color: transparent;
`

export const GradientText = styled.span`
  ${gradientText}
  display: block;

  padding-bottom: 0.15em;
  margin-bottom: -0.15em;
`

export const Eyebrow = styled.span<{ $light?: boolean }>`
  display: block;
  margin-bottom: 8px;
  color: ${({ $light }) => ($light ? "#94a3b8" : textGrey)};
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 1.5px;
  text-transform: uppercase;
`

export const PrimaryButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 12px 24px;
  border: none;
  border-radius: 999px;
  background: linear-gradient(90deg, #8ce4f5 0%, #6fd6ec 100%);
  color: ${textDark};
  cursor: pointer;
  font-family: inherit;
  font-size: 0.875rem;
  font-weight: 400;

  &:hover {
    filter: brightness(1.05);
  }
`

const Badge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 14px 6px 6px;
  border-radius: 999px;
  background: #fff;
  box-shadow: 0 2px 8px rgb(15 23 42 / 8%);
  color: ${textGrey};
  font-size: 0.75rem;

  b {
    color: ${textDark};
  }
`

const BadgeAvatar = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: #2eb8c9;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
`

export const ReferralAgentContext = createContext<ApiTypes.Model.PublicReferralAgent | null>(null)

export const useReferralAgent = () => useContext(ReferralAgentContext)

export const ReferrerBadge = () => {
  const agent = useReferralAgent()
  if (!agent) return null

  const initials = agent.name
    .split(" ")
    .map(part => part[0])
    .slice(0, 2)
    .join("")
    .toUpperCase()

  return (
    <Badge>
      <BadgeAvatar>{initials}</BadgeAvatar>
      <span>
        A gift from <b>{agent.name}</b>
        {agent.brokerage_name ? ` · ${agent.brokerage_name}` : ""}
      </span>
    </Badge>
  )
}
